// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","content":"Footer_content__UYCWF","active":"Footer_active__4cXhz"};